import { Component, OnInit, EventEmitter, Input, Output, OnChanges, SimpleChanges } from '@angular/core';

@Component({
  selector: 'app-display-error',
  templateUrl: './display-error.component.html',
  styleUrls: ['./display-error.component.scss']
})
export class DisplayErrorComponent implements OnInit, OnChanges {

  @Input() ErrorMsg: string;
  @Output() ErrorMsgChange = new EventEmitter<string>();
  errorDuration = 6000;
  displayDelay = 150;
  error = false;
  constructor() { }

  ngOnInit() {
  }

  ngOnChanges(changes: SimpleChanges) {
    for (const propName in changes) {
      if (propName === 'ErrorMsg') {
        if (this.ErrorMsg) {
          setTimeout(() => {
            this.error = true;
          }, this.displayDelay);
          setTimeout(() => {
            this.ErrorMsg = null;
            this.ErrorMsgChange.emit();
            this.error = false;
          }, this.errorDuration);
        }
      }
    }
  }
}



// WEBPACK FOOTER //
// /usr/src/app/src/app/components/display-error/display-error.component.ts